module.exports = __webpack_public_path__ + "static/media/metro_bank.02ee325e.jpg";